const Hotel = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="0 25 100 95"
  >
    <path
      fill={color}
      d="M10.924,84.883v14.492H3.333V46.328c0-2.096,1.699-3.815,3.795-3.815l0,0c2.123,0,3.795,1.719,3.795,3.815v31.367H96.55  v21.68h-7.656V84.883H10.924z"
    ></path>
    <path
      fill="#000064"
      opacity=".2"
      d="M10.924,84.883v14.492H3.333V46.328c0-2.096,1.699-3.815,3.795-3.815l0,0c2.123,0,3.795,1.719,3.795,3.815v31.367H96.55  v21.68h-7.656V84.883H10.924z"
    ></path>

    <path
      fill={color}
      opacity=".95"
      d="M22.624,61.614c3.796,0,6.869-3.072,6.869-6.888c0-3.789-3.073-6.862-6.869-6.862c-3.815,0-6.888,3.073-6.888,6.862  C15.736,58.542,18.809,61.614,22.624,61.614z"
    ></path>
    <path
      fill={color}
      opacity="1"
      d="M96.667,71.992l-0.026-9.466c-0.026-3.008-2.552-5.078-5.481-5.443l-54.05-5.377c-0.117-0.026-0.208-0.078-0.306-0.078  c-1.862,0-3.379,1.523-3.379,3.372v10.208H19.284c-1.888,0-3.398,1.537-3.398,3.398c0,1.875,1.511,3.386,3.398,3.386H96.667z"
    ></path>
  </svg>
);

export default Hotel;
